/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { APP_BASE_HREF } from '@angular/common';
//import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {  NgModule, ErrorHandler, Injectable } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularFireLite } from 'angularfire-lite';
import { environment } from '../environments/environment';
import { DataService } from './services/data/data.service';
import { AuthGuard } from './auth.guard';
import { NbAuthService }  from '@nebular/auth';

//import { NbTooltipModule }  from '@nebular/theme';

//import * as firebase from 'firebase/app';

import { NB_AUTH_TOKEN_CLASS, NbAuthJWTToken } from '@nebular/auth';
import { NotyfModule } from 'ng-notyf';

import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';


//import { NbAuthModule } from '@nebular/auth';


//import { NgAisModule } from 'angular-instantsearch';
//import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
//import * as Sentry from "@sentry/browser";
/*
Sentry.init({
  dsn: "https://c09ed44136e246df82cbb8db25811ed9@sentry.io/1550615"
});

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor() {}
  handleError(error) {
    //const eventId = Sentry.captureException(error.originalError || error);
    //Sentry.showReportDialog({ eventId });
  }
}
*/
@NgModule({
  declarations: [AppComponent],
  imports: [
    //CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule.forRoot(),
    AngularFireLite.forRoot(environment.config),
    AngularFireModule.initializeApp(environment.config),
    AngularFirestoreModule,
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    NotyfModule,
    //NgxDaterangepickerMd.forRoot(),
    //NgAisModule.forRoot()
    //NbTooltipModule,


  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: NB_AUTH_TOKEN_CLASS, useValue: NbAuthJWTToken },
   // { provide: ErrorHandler, useClass: SentryErrorHandler },
    DataService,
    AuthGuard,
   // NbAuthService

  ],
})
export class AppModule {
}

